<div class="auth-wrapper align-items-stretch aut-bg-img" (window:resize)="onResize($event)">
  <div class="flex-grow-1">
    <div class="h-100 d-md-flex align-items-center auth-side-img">
      <div class="col-sm-10 auth-content w-auto">
        <img src="assets/img/logo-implementos.png" alt="Logo Implementos" class="img-fluid" style="width: 37% !important" />
        <h1 class="text-white my-4">Bienvenido a CMS</h1>
        <h4 class="text-white font-weight-normal">Implementos es la red de repuestos insumos y accesorios para camiones,
          buses y remolques más grande del país.</h4>
      </div>
    </div>
    <div class="auth-side-form">
      <div class="auth-content">
        <img *ngIf="innerWidth < 427" src="assets/img/implementos-logo.png" alt="Logo Implementos" class="img-fluid"
          style="width: 22% !important" />
        <h4 *ngIf="innerWidth < 427" class="title-movil">Bienvenido Administración</h4>
        <h3 class="fw-bold mb-3" [class.text-center]="innerWidth < 427">Iniciar Sesión</h3>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="p-fluid">
            <p>Para iniciar sesión ingresa tu usuario y contraseña</p>
            <!-- <div class="input-group mb-3">
              <input formControlName="username" type="usuario" class="form-control" placeholder="Usuario" />
            </div> -->
            <!-- <div class="input-group mb-4">
              <input formControlName="password" type="password" class="form-control" placeholder="Contraseña" />
            </div> -->
            <div class="flex flex-column mb-4 w-full p-0 m-0">
              <div class="field col-12 p-0 m-0">
                <label for="user" class="font-bold font-gray-800 text-muted">Usuario</label>
                <input id="user" formControlName="username" type="text" pInputText
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f['username'].invalid}" />
                <div *ngIf="submitted && f['username'].invalid" class="p-error mt-1 text-xs">
                  Por favor, ingrese su usuario.
                </div>
              </div>
            </div>
            <div class="flex flex-column mb-3 w-full p-0 m-0">
              <div class="field col-12 p-0 m-0">
                <label for="nickname" class="font-bold font-gray-800 text-muted">Contraseña</label>
                <input class="p-mt-3" type="password" formControlName="password" pInputText
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f['password'].invalid}" />
                <div *ngIf="submitted && f['password'].invalid" class="p-error mt-1 text-xs">
                  Por favor, ingrese su contraseña.
                </div>
              </div>
            </div>
            <div class="d-grid mt-5">
              <button type="submit" [disabled]="loading"
                class="btn btn-primary w-full rounded-pill fw-bold d-flex align-items-center justify-content-center">
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-3" role="status"
                  aria-hidden="true"></span>
                  &nbsp;  {{ loading ? 'Ingresando' : 'Acceder' }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
